import React from 'react';
import BrandPage from './BrandPage';

const SandenPage = () => <BrandPage brandSlug="sanden" />;

export default SandenPage;
